// Barvy prostředí — jeden zdroj pravdy pro environment badge (LoginGate), proužek v hlavním menu
// a barevný „ENV: …" text v patičce desktopu. Klíčováno dle `getRuntimeConfig().app.environment`.
// Hodnoty převzaté z designového handoffu (Login dialog.html → `.phx-env`).

export interface EnvColor {
  /** Sytá barva prostředí — pozadí badge, barva proužku i patičkového textu. */
  readonly bg: string;
  /** Kontrastní popředí — text uvnitř badge pilulky. */
  readonly fg: string;
}

/** Fallback (produkce i neznámé klíče, např. „env") — zelená. */
export const ENV_FALLBACK: EnvColor = { bg: '#1F8A5B', fg: '#FFFFFF' };

const ENV_COLORS: Record<string, EnvColor> = {
  prod: ENV_FALLBACK,
  test: { bg: '#2FA84F', fg: '#FFFFFF' },
  dev: { bg: '#2B5C8C', fg: '#FFFFFF' },
};

/** Barva prostředí podle klíče; neznámý/prázdný klíč → zelený {@link ENV_FALLBACK}. */
export function envColor(env: string): EnvColor {
  return ENV_COLORS[env] ?? ENV_FALLBACK;
}

/**
 * Má se zobrazit environment indikátor (proužek v menu / patička)? Ano pro každé ne-produkční
 * prostředí (dev, test, env, …); ne pro produkci ani prázdnou (nenakonfigurovanou) hodnotu.
 */
export function showEnvIndicator(env: string): boolean {
  const normalized = env.trim().toLowerCase();
  return normalized !== '' && normalized !== 'prod' && normalized !== 'production';
}
